export default __webpack_public_path__ + "static/media/Breach_Exclamation_Icon.c1764e9a.svg";